import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/constants";

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 sm:py-32 relative"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="lg:col-span-6 order-2 lg:order-1"
                    >
                        <div className="relative">
                            <div className="absolute -inset-2 bg-yellow-brand opacity-20 blur-2xl pointer-events-none" />
                            <div className="relative border-4 border-pink-brand brutal-shadow-yellow overflow-hidden">
                                <img
                                    src={ASSETS.visionPromo}
                                    alt="LeBron — Highest in the Room"
                                    data-testid="about-img"
                                    className="w-full block"
                                />
                            </div>
                            <div className="absolute -bottom-3 -left-3 bg-yellow-brand text-[#0a0806] px-4 py-2 font-display text-xl uppercase -rotate-2">
                                Highest in the room
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="lg:col-span-6 order-1 lg:order-2"
                    >
                        <div className="font-mono-soft text-xs uppercase tracking-[0.3em] text-pink-brand mb-4">
                            // The Vision
                        </div>
                        <h2 className="font-display text-5xl sm:text-6xl md:text-7xl uppercase leading-[0.9] mb-6">
                            Built on a meme. <br />
                            <span className="text-pink-brand">Powered</span> <br />
                            <span className="text-yellow-brand">by community.</span>
                        </h2>
                        <p className="text-lg text-white/75 leading-relaxed mb-4">
                            <span className="text-yellow-brand font-bold">LeBonBon</span> ($LBRON) is the meme that became a movement.
                            Built around the iconic image of a small guy holding his little cup — a vibe that hits different in every corner of crypto Twitter and Telegram.
                        </p>
                        <p className="text-lg text-white/75 leading-relaxed">
                            We're not chasing pumps. We're building a real community first — one that understands what we're doing,
                            why we're doing it, and where this is going. If you're here now, you're early. Hold the cup.
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
